(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-simple"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Hero slider
  var slider = document.querySelector('[data-brp-hero]');
  if (slider) {
    var dots = document.querySelectorAll('[data-brp-dot]');
    var total = dots.length;
    var current = 0;
    var startX = 0;

    function goTo(n) {
      current = (n + total) % total;
      slider.scrollTo({ left: current * slider.offsetWidth, behavior: 'smooth' });
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.getAttribute('data-brp-dot')));
      });
    });

    var heroWrap = document.querySelector('.brp-pdp__hero');
    if (heroWrap) {
      heroWrap.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      heroWrap.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    slider.addEventListener('scroll', function() {
      var idx = Math.round(slider.scrollLeft / slider.offsetWidth);
      if (idx !== current) {
        current = idx;
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === current);
        });
      }
    }, { passive: true });
  }

  // Video modal
  function initBrpVideo() {
    var videoOpenBtns = document.querySelectorAll('[data-brp-video-open]');
    var videoModal = document.querySelector('[data-brp-video-modal]');
    var videoCloseBtn = document.querySelector('[data-brp-video-close]');
    if (!videoModal || !videoOpenBtns.length) return;
    videoOpenBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { videoModal.showModal(); });
    });
    if (videoCloseBtn) {
      videoCloseBtn.addEventListener('click', function() {
        videoModal.close();
        videoModal.querySelectorAll('video').forEach(function(v) { v.pause(); });
      });
    }
    videoModal.addEventListener('click', function(e) {
      if (e.target === videoModal) {
        videoModal.close();
        videoModal.querySelectorAll('video').forEach(function(v) { v.pause(); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrpVideo);
  } else {
    initBrpVideo();
  }
})();
  // Accordion toggle
  document.querySelectorAll('.accordion-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var content = btn.nextElementSibling;
      content.hidden = expanded;
    });
  });


  } catch(e) { console.error(e); }
})();
})();
